// quillConfig.js
export const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    [{ header: [1, 2, 3, false] }],
    ['clean'],
  ],
  clipboard: {
    matchVisual: false, // ✅ REQUIRED (from Quill docs)
  },
};

export const quillFormats = ['bold', 'italic', 'underline', 'list', 'bullet', 'link', 'header'];
